import themeColors from 'assets/theme/colors'

const classes = {
  mainBox: {
    width: 'min(86vw, 320px)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: themeColors.kroemtech.background,
    // The drawer renders in a portal outside the page's <main>, so it has to
    // restate the site font rather than inherit it.
    fontFamily: 'Verdana, sans-serif'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 1.25rem',
    background: themeColors.bg.start
  },
  closeIcon: {
    color: '#fff',
    cursor: 'pointer',
    transform: 'scale(1.1)',
    '&:hover': { opacity: 0.8 }
  },
  // Scrolls on its own so the language switcher stays pinned to the bottom.
  nav: {
    flex: 1,
    overflowY: 'auto',
    padding: '0.5rem 0'
  },
  sectionLabel: {
    display: 'block',
    padding: '1.1rem 1.25rem 0.4rem',
    fontSize: '0.7rem',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase' as 'uppercase',
    color: themeColors.success.darker
  },
  sectionLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.85rem',
    padding: '0.75rem 1.25rem',
    color: themeColors.gray.dark,
    fontSize: '1rem',
    fontWeight: 600,
    textDecoration: 'none',
    '&:hover': { background: themeColors.section.light }
  },
  childLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.85rem',
    padding: '0.65rem 1.25rem 0.65rem 2rem',
    color: themeColors.gray.defaultText,
    fontSize: '0.9375rem',
    textDecoration: 'none',
    '&:hover': { background: themeColors.section.light }
  },
  // A subgroup heads a set of pages but has none of its own, so it is a
  // label rather than a link. Its pages sit one indent deeper.
  groupLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.85rem',
    padding: '0.65rem 1.25rem 0.65rem 2rem',
    color: themeColors.gray.dark,
    fontSize: '0.9375rem',
    fontWeight: 600
  },
  groupChildLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.85rem',
    padding: '0.55rem 1.25rem 0.55rem 0.9rem',
    marginLeft: '2.4rem',
    borderLeft: `2px solid ${themeColors.gray.lighter}`,
    color: themeColors.gray.defaultText,
    fontSize: '0.9375rem',
    textDecoration: 'none',
    '&:hover': { background: themeColors.section.light }
  },
  icon: {
    fontSize: '1.25rem',
    color: themeColors.bg.start,
    flexShrink: 0
  },
  divider: {
    borderTop: `1px solid ${themeColors.gray.lighter}`,
    margin: '0.75rem 1.25rem 0'
  },
  ctaBox: {
    padding: '1.25rem'
  },
  legalBox: {
    display: 'flex',
    flexWrap: 'wrap' as 'wrap',
    gap: '0.25rem 1rem',
    padding: '0 1.25rem 1rem'
  },
  legalLink: {
    fontSize: '0.75rem',
    color: themeColors.gray.mid,
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' }
  },
  footerBox: {
    borderTop: `1px solid ${themeColors.gray.lighter}`,
    padding: '1rem 1.25rem',
    display: 'flex',
    justifyContent: 'center'
  }
}

export default classes
